import angular from 'angular'
import moment from 'moment'
import addRemoveUsersSchoolDomainModalCtrl from './add_remove_users_school_domain/add_remove_users_school_domain'
import changeLicenseEndDatesCtrl from './change_license_end_dates/change_license_end_dates'
import deleteLicensesCtrl from './delete_licenses/delete_licenses'
import deleteUsersCtrl from './delete_users/delete_users'
import editRBACRoleCtrl from './edit_user_info/edit_rbac_role'
import editAccountCtrl from './edit_user_info/edit_account'
import editPwUserCtrl from './edit_user_info/edit_pathways_user'
import editTkUserCtrl from './edit_user_info/edit_toolkit_user'
import editMonthlyQuotasCtrl from './edit_user_info/edit_monthly_quotas'
import editUserInfoCtrl from './edit_user_info/edit_user_info'
import batchEditAccountsCtrl from './edit_user_info/batch_edit_accounts'
import UAEditDefaultQuotasCtrl from './edit_user_info/edit_default_quotas'
import exportUsersCtrl from './export_users/export_users'
import exportUsersXLSXCtrl from './export_users/export_users_xlsx'
import provisionLicensesCtrl from './provision_licenses/provision_licenses'
import resetPasswordsCtrl from './reset_passwords/reset_passwords'
import requirePasswordResetCtrl from './require_password_reset/require_password_reset'
import signUserOutCtrl from './sign_user_out/sign_user_out'
import manageTagsCtrl from './manage_tags'
import generateUserCodesCtrl from './generate_use_codes'
import batchCopyFoldersCtrl from './batch_copy_folders/batch_copy_folders'
import downloadBinToFile from '../scripts/file_download'
import { Permissions } from '../client_auth/permissions'

userActions.$inject = ['$uibModal', '$q', '$window', 'graph', 'auth', 'domainInfo', 'configuration', 'adminEntitiesApi']

export default function userActions($modal, $q, $window, graph, auth, domainInfoService, config, adminEntitiesApi) {
  var userActions = {
    actions: [
      {
        label: 'Provision Toolkit license',
        key: 'provisionToolkit',
        requiredPermissions: [Permissions.LicenseOps]
      },
      {
        label: 'Provision Pathways license',
        key: 'provisionPathways',
        requiredPermissions: [Permissions.LicenseOps]
      },
      {
        label: 'Change Toolkit end date',
        key: 'changeToolkitEndDate',
        requiredPermissions: [Permissions.LicenseOps]
      },
      {
        label: 'Change Pathways end date',
        key: 'changePathwaysEndDate',
        requiredPermissions: [Permissions.LicenseOps]
      },
      {
        label: 'Delete licenses',
        key: 'deleteLicenses',
        requiredPermissions: [Permissions.UserOps]
      },
      null,
      { label: 'Export users as csv', key: 'exportSelectedUsersAsCSV' },
      {
        label: 'Export users as xlsx',
        key: 'exportSelectedUsersAsXLSX'
      },
      { label: 'Add tags', key: 'addTagsToUsers', requiredPermissions: [Permissions.UserOps] },
      { label: 'Remove tags', key: 'removeTagsFromUsers', requiredPermissions: [Permissions.UserOps] },
      null,
      { label: 'Add users to schools', key: 'addUsersToSchools', requiredPermissions: [Permissions.LicenseOps] },
      { label: 'Remove users from schools', key: 'removeUsersFromSchools', requiredPermissions: [Permissions.LicenseOps] },
      { label: 'Add users to subgroups', key: 'addUsersToSubgroups', requiredPermissions: [Permissions.UserOps] },
      { label: 'Remove users from subgroups', key: 'removeUsersFromSubgroups', requiredPermissions: [Permissions.UserOps] },
      { label: 'Remove users from domain', key: 'removeUsersFromDomain', requiredPermissions: [Permissions.UserOps] },
      { label: 'Reset passwords', key: 'resetPassword' },
      { label: 'Generate use code', key: 'generateUseCode' },
      { label: 'Batch update accounts', key: 'batchEditAccounts', requiredPermissions: [Permissions.UserOps] },
      {
        label: 'Batch update Toolkit default quotas',
        key: 'updateToolkitDefaultQuotas',
        requiredPermissions: [Permissions.QuotaOps]
      },
      {
        label: 'Batch update Pathways default quotas',
        key: 'updatePathwaysDefaultQuotas',
        requiredPermissions: [Permissions.QuotaOps]
      },
      null,
      { label: 'Update user info cache', key: 'updateUserInfoCache' },
      null,
      {
        label: 'Delete users',
        key: 'deleteUsers',
        requiredPermissions: [Permissions.UserOps]
      }
    ],

    individualActions: [
      {
        label: 'Provision Toolkit license',
        key: 'provisionToolkit',
        requiredPermissions: [Permissions.LicenseOps]
      },
      {
        label: 'Provision Pathways license',
        key: 'provisionPathways',
        requiredPermissions: [Permissions.LicenseOps]
      },
      {
        label: 'Delete licenses',
        key: 'deleteLicenses',
        requiredPermissions: [Permissions.UserOps]
      },

      null,

      { label: 'Edit name, title, email, or timezone', key: 'editUserInfo', requiredPermissions: [Permissions.LicenseOps] }, // name, email, title - things that are in both graph and account
      { label: 'Edit content role', key: 'editRBACRole' },
      { label: 'Edit account', key: 'editAccount', requiredPermissions: [Permissions.LicenseOps] },

      { label: 'Edit Toolkit account', key: 'editToolkitAccount', requiredPermissions: [Permissions.UserOps] },
      { label: 'Edit Pathways account', key: 'editPathwaysAccount', requiredPermissions: [Permissions.UserOps] },
      {
        label: 'Adjust quotas for this month',
        key: 'editMontlyQuotas',
        requiredPermissions: [Permissions.QuotaOps]
      },
      { label: 'Reset password', key: 'resetPassword' },
      { label: 'Require password reset', key: 'requirePasswordReset', requiredPermissions: [Permissions.UserOps] },

      null,

      { label: 'Add user to schools', key: 'addUsersToSchools', requiredPermissions: [Permissions.LicenseOps] },
      { label: 'Remove user from schools', key: 'removeUsersFromSchools', requiredPermissions: [Permissions.LicenseOps] },
      { label: 'Add user to subgroups', key: 'addUsersToSubgroups', requiredPermissions: [Permissions.UserOps] },
      { label: 'Remove use from subgroups', key: 'removeUsersFromSubgroups', requiredPermissions: [Permissions.UserOps] },
      { label: 'Add user to domain', key: 'addUsersToDomain', requiredPermissions: [Permissions.LicenseOps] },
      { label: 'Remove user from domain', key: 'removeUsersFromDomain', requiredPermissions: [Permissions.UserOps] },

      null,

      {
        label: 'Delete user',
        key: 'deleteUsers',
        requiredPermissions: [Permissions.UserOps]
      },

      null,

      { label: 'Sign into Toolkit', key: 'signinToolkit', requiredPermissions: [Permissions.UserOps] },
      { label: 'Sign into Pathways', key: 'signinPathways', requiredPermissions: [Permissions.UserOps] },

      null,
      
      { label: 'Batch copy Toolkit folders', key: 'batchCopyFolders', requiredPermissions: [Permissions.UserOps] },

      null,

      { label: 'Sign user out', key: 'signoutEverywhere', requiredPermissions: [Permissions.UserOps] }
    ],
    populateIsAuthorized(actions) {
      const promises = actions.map(action => {
        if (!action) {
          return $q.when(null);
        }
        if (!action.requiredPermissions) {
          action.isAuthorized = true;
          return $q.when(action);
        }
        return auth.doesUserHavePermission(action.requiredPermissions).then(isAuthorized => {
          action.isAuthorized = isAuthorized;
          return action;
        });
      });
      return $q.all(promises);
    }
  }

  var unimplementedModal = {
    template:
      '<div class="modal-body"><p>This action is not implemented yet.</p><p><button class="btn btn-default" ng-click="$close()">OK</button></p></div>'
  }

  ////////////////////////////////////////////////////////////////////////
  // These methods need to have the same args: domain, users, school    //
  // Only some methods need to know the domain and school.              //
  ////////////////////////////////////////////////////////////////////////
  userActions.provisionToolkit = function({ domain, users }) {
    var deferred = $q.defer()
    var licenseModal = $modal.open({
      template: require('./provision_licenses/_modalProvisionLicenses.html'),
      controller: provisionLicensesCtrl,
      controllerAs: 'modalCtrl',
      size: 'lg',
      backdrop: 'static',
      resolve: {
        product: function() {
          return 'toolkit'
        },
        users: function() {
          return users
        },
        domainUuid: function() {
          return domain && domain.uuid
        }
      }
    })
    licenseModal.result.then(
      function(importUuid) {
        deferred.resolve(importUuid)
      },
      function(reason) {
        deferred.reject(reason)
      }
    )

    return deferred.promise
  }
  userActions.provisionPathways = function({ domain, users }) {
    var deferred = $q.defer()
    var licenseModal = $modal.open({
      template: require('./provision_licenses/_modalProvisionLicenses.html'),
      controller: provisionLicensesCtrl,
      controllerAs: 'modalCtrl',
      size: 'lg',
      backdrop: 'static',
      resolve: {
        product: function() {
          return 'pathways'
        },
        users: function() {
          return users
        },
        domainUuid: function() {
          return domain && domain.uuid
        }
      }
    })
    licenseModal.result.then(
      function(importUuid) {
        deferred.resolve(importUuid)
      },
      function(reason) {
        deferred.reject(reason)
      }
    )

    return deferred.promise
  }
  userActions.changeToolkitEndDate = function({ domain, users }) {
    var deferred = $q.defer()
    var modal = $modal.open({
      template: require('./change_license_end_dates/_modalChangeLicenseEndDates.html'),
      controller: changeLicenseEndDatesCtrl,
      controllerAs: 'modalCtrl',
      backdrop: 'static',
      resolve: {
        product: function() {
          return 'toolkit'
        },
        users: function() {
          return users
        },
        domainUuid: function() {
          return domain && domain.uuid
        }
      }
    })

    modal.result.then(
      function(result) {
        deferred.resolve(result)
      },
      function(reason) {
        deferred.reject(reason)
      }
    )

    return deferred.promise
  }
  userActions.changePathwaysEndDate = function({ domain, users }) {
    var deferred = $q.defer()
    var modal = $modal.open({
      template: require('./change_license_end_dates/_modalChangeLicenseEndDates.html'),
      controller: changeLicenseEndDatesCtrl,
      controllerAs: 'modalCtrl',
      backdrop: 'static',
      resolve: {
        product: function() {
          return 'pathways'
        },
        users: function() {
          return users
        },
        domainUuid: function() {
          return domain && domain.uuid
        }
      }
    })

    modal.result.then(
      function(result) {
        deferred.resolve(result)
      },
      function(reason) {
        deferred.reject(reason)
      }
    )

    return deferred.promise
  }
  userActions.exportSelectedUsersAsCSV = function({ domain, users }) {
    var deferred = $q.defer()

    var exportingModal = $modal.open({
      controller: exportUsersCtrl,
      controllerAs: 'modalCtrl',
      backdrop: 'static',
      resolve: {
        domain: function() {
          return domain
        },
        users: function() {
          return users
        }
      },
      template: require('./export_users/_modalExportUsers.html')
    })
    exportingModal.result.then(function() {
      deferred.resolve(false)
    })

    return deferred.promise
  }

  userActions.exportSelectedUsersAsXLSX = function({ domain, users }) {
    const deferred = $q.defer()

    const openExportModal = function(skipModal) {
      const exportingModal = $modal.open({
        controller: exportUsersXLSXCtrl,
        controllerAs: 'modalCtrl',
        backdrop: 'static',
        resolve: {
          domain: function() { return domain },
          users: function() { return users },
          configuration: function() { return config },
          skipModal: function() { return skipModal }
        },
        template: require('./export_users/_modalExportUsersXLSX.html')
      })
      
      exportingModal.result.then(
        function() { deferred.resolve(true) },
        function() { deferred.resolve(false) }
      )
    }

    // Check if domain has subgroups
    adminEntitiesApi.listSubgroups({ domain_uuid: domain.uuid })
      .then(function(response) {
        const hasSubgroups = response.data && response.data.length > 0
        openExportModal(!hasSubgroups)
      })
      .catch(function() {
        // On error, show modal anyway
        openExportModal(false)
      })

    return deferred.promise
  }

  userActions.deleteUsers = function({ domain, users }) {
    var deferred = $q.defer()

    var deleteUsersModal = $modal.open({
      controller: deleteUsersCtrl,
      controllerAs: 'modalCtrl',
      backdrop: 'static',
      resolve: {
        users: function() {
          return users
        }
      },
      template: require('./delete_users/_modalDeleteUsers.html')
    })
    deleteUsersModal.result.then(
      function(deleteSummary) {
        deferred.resolve(deleteSummary)
      },
      function() {
        deferred.resolve(false)
      }
    )

    return deferred.promise
  }

  userActions.addUsersToDomain = function({ domain, users }) {
    var deferred = $q.defer()

    var addRemoveUsersSchoolDomainModal = $modal.open({
      controller: addRemoveUsersSchoolDomainModalCtrl,
      controllerAs: 'modalCtrl',
      backdrop: 'static',
      size: 'lg',
      resolve: {
        users: function() {
          return users
        },
        domainUuid: function() {
          return null
        },
        schoolUuids: function() {
          return null
        },
        subgroupUuids: function() {
          return null
        },
        op: function() {
          return 'Add Users to Domain'
        }
      },
      template: require('./add_remove_users_school_domain/_modalAddRemoveUsersSchoolDomain.html')
    })
    addRemoveUsersSchoolDomainModal.result.then(
      function(result) {
        deferred.resolve(result)
      },
      function() {
        deferred.resolve(false)
      }
    )

    return deferred.promise
  }

  userActions.removeUsersFromDomain = function({ domain, users }) {
    var deferred = $q.defer()

    var addRemoveUsersSchoolDomainModal = $modal.open({
      controller: addRemoveUsersSchoolDomainModalCtrl,
      controllerAs: 'modalCtrl',
      backdrop: 'static',
      size: 'lg',
      resolve: {
        users: function() {
          return users
        },
        domainUuid: function() {
          return (domain && domain.uuid) || ''
        },
        schoolUuids: function() {
          return null
        },
        subgroupUuids: function() {
          return null
        },
        op: function() {
          return 'Remove Users from Domain'
        }
      },
      template: require('./add_remove_users_school_domain/_modalAddRemoveUsersSchoolDomain.html')
    })
    addRemoveUsersSchoolDomainModal.result.then(
      function(result) {
        deferred.resolve(result)
      },
      function() {
        deferred.resolve(false)
      }
    )

    return deferred.promise
  }

  userActions.addUsersToSchools = function({ domain, users, schools }) {
    var deferred = $q.defer()

    var addRemoveUsersSchoolDomainModal = $modal.open({
      controller: addRemoveUsersSchoolDomainModalCtrl,
      controllerAs: 'modalCtrl',
      backdrop: 'static',
      size: 'lg',
      resolve: {
        users: function() {
          return users
        },
        schoolUuids: function() {
          return (schools || []).map(school => school.uuid)
        },
        subgroupUuids: function() {
          return null
        },
        domainUuid: function() {
          return (domain && domain.uuid) || ''
        },
        op: function() {
          return 'Add Users to School'
        }
      },
      template: require('./add_remove_users_school_domain/_modalAddRemoveUsersSchoolDomain.html')
    })
    addRemoveUsersSchoolDomainModal.result.then(
      function(result) {
        deferred.resolve(result)
      },
      function() {
        deferred.resolve(false)
      }
    )

    return deferred.promise
  }

  userActions.removeUsersFromSchools = function({ domain, users, schools }) {
    var deferred = $q.defer()

    var addRemoveUsersSchoolDomainModal = $modal.open({
      controller: addRemoveUsersSchoolDomainModalCtrl,
      controllerAs: 'modalCtrl',
      backdrop: 'static',
      size: 'lg',
      resolve: {
        users: function() {
          return users
        },
        schoolUuids: function() {
          return (schools || []).map(school => school.uuid)
        },
        subgroupUuids: function() {
          return null
        },
        domainUuid: function() {
          return (domain && domain.uuid) || ''
        },
        op: function() {
          return 'Remove Users from School'
        }
      },
      template: require('./add_remove_users_school_domain/_modalAddRemoveUsersSchoolDomain.html')
    })
    addRemoveUsersSchoolDomainModal.result.then(
      function(result) {
        deferred.resolve(result)
      },
      function() {
        deferred.resolve(false)
      }
    )

    return deferred.promise
  }

  userActions.addUsersToSubgroups = function({ domain, users, subgroups }) {
    var deferred = $q.defer()

    var addRemoveUsersSchoolDomainModal = $modal.open({
      controller: addRemoveUsersSchoolDomainModalCtrl,
      controllerAs: 'modalCtrl',
      backdrop: 'static',
      size: 'lg',
      resolve: {
        users: function() {
          return users
        },
        schoolUuids: function() {
          return null
        },
        subgroupUuids: function() {
          return (subgroups || []).map(subgroup => subgroup.uuid)
        },
        domainUuid: function() {
          return (domain && domain.uuid) || ''
        },
        op: function() {
          return 'Add Users to Subgroups'
        }
      },
      template: require('./add_remove_users_school_domain/_modalAddRemoveUsersSchoolDomain.html')
    })
    addRemoveUsersSchoolDomainModal.result.then(
      function(result) {
        deferred.resolve(result)
      },
      function() {
        deferred.resolve(false)
      }
    )
    return deferred.promise
  }


  userActions.removeUsersFromSubgroups = function({ domain, users, subgroups }) {
    var deferred = $q.defer()

    var addRemoveUsersSchoolDomainModal = $modal.open({
      controller: addRemoveUsersSchoolDomainModalCtrl,
      controllerAs: 'modalCtrl',
      backdrop: 'static',
      size: 'lg',
      resolve: {
        users: function() {
          return users
        },
        schoolUuids: function() {
          return null
        },
        subgroupUuids: function() {
          return (subgroups || []).map(subgroup => subgroup.uuid)
        },
        domainUuid: function() {
          return (domain && domain.uuid) || ''
        },
        op: function() {
          return 'Remove Users from Subgroups'
        }
      },
      template: require('./add_remove_users_school_domain/_modalAddRemoveUsersSchoolDomain.html')
    })
    addRemoveUsersSchoolDomainModal.result.then(
      function(result) {
        deferred.resolve(result)
      },
      function() {
        deferred.resolve(false)
      }
    )
    return deferred.promise
  }

  userActions.addTagsToUsers = function({ domain, users, allTags }) {
    var deferred = $q.defer()

    var manageTagsModal = $modal.open({
      controller: manageTagsCtrl,
      controllerAs: 'modalCtrl',
      backdrop: 'static',
      resolve: {
        users: function() {
          return users
        },
        op: function() {
          return 'Add Tags to Users'
        },
        allTags: function() {
          return allTags
        }
      },
      template: require('./manage_tags/_template.html')
    })
    manageTagsModal.result.then(
      function(result) {
        deferred.resolve(result)
      },
      function() {
        deferred.resolve(false)
      }
    )

    return deferred.promise
  }
  userActions.removeTagsFromUsers = function({ domain, users, allTags }) {
    var deferred = $q.defer()

    var manageTagsModal = $modal.open({
      controller: manageTagsCtrl,
      controllerAs: 'modalCtrl',
      backdrop: 'static',
      resolve: {
        users: function() {
          return users
        },
        op: function() {
          return 'Remove Tags from Users'
        },
        allTags: function() {
          return allTags
        }
      },
      template: require('./manage_tags/_template.html')
    })
    manageTagsModal.result.then(
      function(result) {
        deferred.resolve(result)
      },
      function() {
        deferred.resolve(false)
      }
    )

    return deferred.promise
  }

  userActions.editUserInfo = function({ domain, users }) {
    var deferred = $q.defer()

    var editInfoModal = $modal.open({
      template: require('./edit_user_info/_modalEditUserInfo.html'),
      controller: editUserInfoCtrl,
      controllerAs: 'modalCtrl',
      backdrop: 'static',
      resolve: {
        user: function() {
          return users[0]
        }
      }
    })
    editInfoModal.result.then(
      function(result) {
        deferred.resolve(result)
      },
      function(reason) {
        deferred.reject(reason)
      }
    )

    return deferred.promise
  }

  userActions.editRBACRole = function({ domain, users }) {
    var deferred = $q.defer()

    var editInfoModal = $modal.open({
      template: require('./edit_user_info/_modalEditRBACRole.html'),
      controller: editRBACRoleCtrl,
      controllerAs: 'modalCtrl',
      backdrop: 'static',
      resolve: {
        user: function() {
          return users[0]
        }
      }
    })
    editInfoModal.result.then(
      function(result) {
        deferred.resolve(result)
      },
      function(reason) {
        deferred.reject(reason)
      }
    )

    return deferred.promise
  }

  userActions.editAccount = function({ domain, users }) {
    var deferred = $q.defer()
    var editAccountModal = $modal.open({
      template: require('./edit_user_info/_modalEditAccount.html'),
      controller: editAccountCtrl,
      controllerAs: 'modalCtrl',
      backdrop: 'static',
      resolve: {
        userAccount: [
          'userInfo',
          function(userInfo) {
            return angular.copy(userInfo.userInfo.user_account)
          }
        ]
      }
    })
    editAccountModal.result.then(
      function(result) {
        deferred.resolve(result)
      },
      function(reason) {
        deferred.reject(reason)
      }
    )

    return deferred.promise
  }

  userActions.batchEditAccounts = function({ users }) {
    var modal = $modal.open({
      template: require('./edit_user_info/_modalBatchEditAccounts.html'),
      controller: batchEditAccountsCtrl,
      controllerAs: 'modalCtrl',
      backdrop: 'static',
      resolve: {
        users: () => users
      }
    })

    return modal.result
  }

  userActions.updateToolkitDefaultQuotas = function({ users }) {
    var modal = $modal.open({
      template: require('./edit_user_info/_modalEditDefaultQuotas.html'),
      controller: UAEditDefaultQuotasCtrl,
      controllerAs: 'modalCtrl',
      backdrop: 'static',
      resolve: {
        userUuids: () => users.map(user => user.uuid),
        product: () => 'toolkit',
        domainInfo: () => domainInfoService.domainInfoRecordUI.domainInfoRecord
      }
    })

    return modal.result
  }

  userActions.updatePathwaysDefaultQuotas = function({ users }) {
    var modal = $modal.open({
      template: require('./edit_user_info/_modalEditDefaultQuotas.html'),
      controller: UAEditDefaultQuotasCtrl,
      controllerAs: 'modalCtrl',
      backdrop: 'static',
      resolve: {
        userUuids: () => users.map(user => user.uuid),
        product: () => 'pathways',
        domainInfo: () => domainInfoService.domainInfoRecordUI.domainInfoRecord
      }
    })

    return modal.result
  }

  userActions.editGraphEntity = function({ domain, users }) {
    var deferred = $q.defer()
    var modal = $modal.open(unimplementedModal)
    modal.result.then(
      function(result) {
        deferred.resolve(result)
      },
      function(reason) {
        deferred.reject(reason)
      }
    )

    return deferred.promise
  }

  userActions.editToolkitAccount = function({ domain, users }) {
    var deferred = $q.defer()
    var modal = $modal.open({
      template: require('./edit_user_info/_modalEditToolkitUser.html'),
      controller: editTkUserCtrl,
      controllerAs: 'modalCtrl',
      backdrop: 'static',
      resolve: {
        user: [
          'userInfo',
          function(userInfo) {
            return angular.copy(userInfo.userInfo.toolkit_account)
          }
        ]
      }
    })

    modal.result.then(
      function(result) {
        deferred.resolve(result)
      },
      function(reason) {
        deferred.reject(reason)
      }
    )

    return deferred.promise
  }

  userActions.editPathwaysAccount = function({ domain, users }) {
    var deferred = $q.defer()
    var modal = $modal.open({
      template: require('./edit_user_info/_modalEditPathwaysUser.html'),
      controller: editPwUserCtrl,
      controllerAs: 'modalCtrl',
      backdrop: 'static',
      resolve: {
        user: [
          'userInfo',
          function(userInfo) {
            return angular.copy(userInfo.userInfo.pathways_account)
          }
        ]
      }
    })

    modal.result.then(
      function(result) {
        deferred.resolve(result)
      },
      function(reason) {
        deferred.reject(reason)
      }
    )

    return deferred.promise
  }

  userActions.editMontlyQuotas = function({ domain, users }) {
    var deferred = $q.defer()
    var modal = $modal.open({
      template: require('./edit_user_info/_modalEditMonthlyQuotas.html'),
      controller: editMonthlyQuotasCtrl,
      controllerAs: 'modalCtrl',
      backdrop: 'static',
      resolve: {
        userUuid: [
          'userInfo',
          function(userInfo) {
            return userInfo.userInfo.user_graph.uuid
          }
        ],
        domainUuid: [
          'userInfo',
          function(userInfo) {
            return userInfo.userInfo.domains[0].uuid || 'no_domain'
          }
        ],
        quotas: [
          'userInfo',
          function(userInfo) {
            // only pull out the quota fields of the content access report
            var quotas = {},
              accessReport = userInfo.userInfo.content_access_report,
              quotaKeys = Object.keys(accessReport)
                .filter(function(q) {
                  return q.includes('_quota')
                })
                .forEach(function(key) {
                  quotas[key] = accessReport[key]
                })

            return quotas
          }
        ]
      }
    })

    modal.result.then(
      function(result) {
        deferred.resolve(result)
      },
      function(reason) {
        deferred.reject(reason)
      }
    )

    return deferred.promise
  }

  userActions.resetPassword = function({ domain, users }) {
    var deferred = $q.defer()
    var modal = $modal.open({
      template: require('./reset_passwords/_modalResetPasswords.html'),
      controller: resetPasswordsCtrl,
      controllerAs: 'modalCtrl',
      resolve: {
        users: function() {
          return users
        },
        domainUuid: function() {
          return (domain && domain.uuid) || ''
        }
      }
    })
    modal.result.then(
      function(result) {
        deferred.resolve(result)
      },
      function(reason) {
        deferred.reject(reason)
      }
    )

    return deferred.promise
  }

  userActions.generateUseCode = function({ domain, users }) {
    return $modal.open({
      template: require('./generate_use_codes/_template.html'),
      controller: generateUserCodesCtrl,
      controllerAs: 'modalCtrl',
      resolve: {
        userUuids: () => users.map(user => user.uuid),
        domainUuid: () => domain.uuid
      }
    }).result
  }

  userActions.updateUserInfoCache = function({ users }) {
    return domainInfoService.refreshUserCache({
      userUuids: users.map(u => u.uuid)
    })
  }

  userActions.giveILPAccess = function({ domain, users }) {
    var userUuids = users.map(user => user.uuid).filter(uuid => uuid)
    return graph.toggleILPAccess(userUuids, { set: true })
  }

  userActions.removeILPAccess = function({ domain, users }) {
    var userUuids = users.map(user => user.uuid).filter(uuid => uuid)
    return graph.toggleILPAccess(userUuids, { set: false })
  }

  // for now, this just creates an import with users pre-selected
  // and redirects to the licenses preview for the import
  userActions.deleteLicenses = function({ domain, users }) {
    var deferred = $q.defer()
    var modal = $modal.open({
      template: require('./delete_licenses/_modalDeleteLicensesForUsers.html'),
      controller: deleteLicensesCtrl,
      controllerAs: 'modalCtrl',
      resolve: {
        users: function() {
          return users
        },
        domainUuid: function() {
          return (domain && domain.uuid) || ''
        }
      }
    })
    modal.result.then(
      function(result) {
        deferred.resolve(result)
      },
      function(reason) {
        deferred.reject(reason)
      }
    )

    return deferred.promise
  }

  userActions.signoutEverywhere = async function({ users }) {
    const ariaLabelledBy = 'modal-title-sign-user-out'
    var modal = $modal.open({
      template: require('./sign_user_out/_modalSignUserOut.html'),
      controller: signUserOutCtrl,
      controllerAs: 'modalCtrl',
      ariaLabelledBy,
      resolve: {
        users: () => users,
        modalTitleID: () => ariaLabelledBy
      }
    })
    try {
      return await modal.result
    } catch (err) {
      return err
    }
  }

  userActions.requirePasswordReset = async function({ users }) {
    const ariaLabelledBy = 'modal-title-require-password-reset'
    const modal = $modal.open({
      template: require('./require_password_reset/_modalRequirePasswordReset.html'),
      controller: requirePasswordResetCtrl,
      controllerAs: 'modalCtrl',
      // ariaLabelledBy,
      resolve: {
        users: () => users,
        modalTitleID: () => ariaLabelledBy
      }
    })
    try {
      return await modal.result
    } catch (err) {
      return err
    }
  }

  // only cares about the first user since you can't log in multiple people
  // domain ignored
  userActions.signinToolkit = function({ domain, users }) {
    var promise = auth.signInRack(users[0].uuid)
    promise.then(
      function(userUuid) {
        $window.open(config.toolkitRoot)
      },
      function(resp) {
        $window.alert('Error signing into Toolkit: ' + resp)
      }
    )
    return promise
  }
  // only cares about the first user since you can't log in multiple people
  // domain ignored
  userActions.signinPathways = function({ domain, users }) {
    var promise = auth.signInRack(users[0].uuid)
    promise.then(
      function(userUuid) {
        $window.open(config.pathwaysRoot)
      },
      function(resp) {
        $window.alert('Error signing into Pathways: ' + resp)
      }
    )
    return promise
  }
  // only cares about the first user since you can't log in multiple people
  // domain ignored
  userActions.signinILP = function({ domain, users }) {
    if (users[0].ilp_access) {
      var promise = auth.signInRack(users[0].uuid)
      promise.then(
        function(userUuid) {
          var ilpRoot = config.toolkitRoot.replace('toolkit', 'goals')
          $window.open(ilpRoot)
        },
        function(resp) {
          $window.alert('Error signing into ILP: ' + resp)
        }
      )
      return promise
    } else {
      console.error('User does not have ILP access')
    }
  }

  /**
   * Batch copy Toolkit folders from one user to another
   */
  userActions.batchCopyFolders = function({ domain, users }) {
    var deferred = $q.defer()
    
    var batchCopyModal = $modal.open({
      template: require('./batch_copy_folders/_modalBatchCopyFolders.html'),
      controller: batchCopyFoldersCtrl,
      controllerAs: 'modalCtrl',
      backdrop: 'static',
      resolve: {
        users: function() {
          return users
        },
        userInfo: ['userInfo', function(userInfo) {
          return userInfo
        }]
      }
    })
    
    batchCopyModal.result.then(
      function(result) {
        deferred.resolve(result)
      },
      function() {
        deferred.resolve(false)
      }
    )

    return deferred.promise
  }

  return userActions
}
